import React, { FC } from 'react';
import ProfilePage from 'src/components/UI/profile/Profile';

const Profile: FC = () => <ProfilePage />;

export default Profile;
